const clock_restore = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%201c6.075%200%2011%204.925%2011%2011s-4.925%2011-11%2011S1%2018.075%201%2012h2a9%209%200%201%200%209-9c-2.84%200-4.955.791-6.886%203H8v2H2V1.991h2v2.265C6.237%201.911%208.787%201%2012%201zm1%205v5h4v2h-6V6h2z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  clock_restore as default
};
//# sourceMappingURL=clock_restore.svg.es.js.map
